import { Alert, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { ReactNode } from 'react';

import { ErrorIcon, InfoIcon, WarningIcon } from '@/components/StatusIcons';
import { boldWeight } from '@/theme';

export type AlertChipProps = {
    severity: 'info' | 'warning' | 'error';
    label: ReactNode;
};

const levelIcon: Record<AlertChipProps['severity'], OverridableComponent<SvgIconTypeMap>> = {
    info: InfoIcon,
    warning: WarningIcon,
    error: ErrorIcon,
};

export const AlertChip = ({ severity, label }: AlertChipProps) => {
    const Icon = levelIcon[severity];

    return (
        <Alert
            icon={<Icon />}
            severity={severity}
            variant="outlined"
            sx={(theme) => ({
                backgroundColor: `${theme.palette[severity].main}18`,
                borderRadius: 1,
                borderColor: `${severity}.main`,
                fontWeight: boldWeight,
                fontSize: '0.875rem',
                justifySelf: 'start',
                pt: '3px',
                pb: '1px',
                pl: 0.5,
                pr: 1,
                '.MuiAlert-message': {
                    p: 0,
                },
                '.MuiAlert-icon': {
                    p: 0,
                    mr: 0.5,
                    mt: '-1px',
                    fontSize: '1em',
                    svg: {
                        fontSize: '1.4em',
                    },
                },
            })}
        >
            {label}
        </Alert>
    );
};
